import { useQuery } from '@tanstack/react-query'
import { apiGet } from '@/lib/api'

export interface DashboardLesson {
  id: string
  title: string | null
  startTime: string
  endTime: string
  groupName: string | null
  trainerName: string | null
  studentCount: number
  maxCapacity: number
}

export interface DashboardStudent {
  id: string
  firstName: string
  lastName: string
  registrationDate: string
  createdAt: string
}

export interface DashboardStats {
  totalStudents: number
  activeStudents: number
  todayAttendance: number
  monthlyRevenue: number
  pendingPaymentsCount: number
  pendingPaymentsAmount: number
  upcomingLessons: DashboardLesson[]
  recentStudents: DashboardStudent[]
}

export const useDashboardStats = () =>
  useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => apiGet<DashboardStats>('/dashboard/stats'),
    staleTime: 60_000,
  })
